import { getText } from '../internal/TextLabels/text'
import { months, weekDays } from './calenderConstants'

export const aggregateRawData = rawData => {
  const map = new Map()
  Object.keys(rawData).forEach(i => {
    Object.keys(rawData[i]).forEach(p => {
      if (p !== 'name') {
        if (map.has(p)) {
          map.set(p, map.get(p) + rawData[i][p])
        } else {
          map.set(p, rawData[i][p])
        }
      }
    })
  })

  return map
}

export const normalizeBarData = rawData => {
  const agg = aggregateRawData(rawData)

  Object.keys(rawData).forEach(i => {
    agg.forEach((val, key) => {
      if (!Object.prototype.hasOwnProperty.call(rawData[i], key)) {
        // eslint-disable-next-line no-param-reassign
        rawData[i][key] = 0
      }
    })
  })

  return rawData
}

export const flattenJson = ob => {
  const toReturn = {}
  Object.keys(ob).forEach(i => {
    if (typeof ob[i] === 'object') {
      const flatObject = flattenJson(ob[i])
      Object.keys(flatObject).forEach(x => {
        toReturn[`${x}`] = flatObject[x]
      })
    } else if (months.includes(ob[i])) {
      toReturn[i] = getText(`statistics.month.${ob[i]}`)
    } else if (weekDays.includes(ob[i])) {
      toReturn[i] = getText(`statistics.weekDay.${ob[i]}`)
    } else {
      toReturn[i] = ob[i]
    }
  })
  return toReturn
}

export const prepareForChart = rawData => {
  const newArray = []
  if (typeof rawData !== 'undefined') {
    rawData.forEach(d => {
      const item = flattenJson(d)
      const newItem = {}
      Object.keys(item).forEach(key => {
        let newKey = key
        if (key !== 'name') {
          const toTranslateArr = key.match(/\${(.*?)}/)

          if (toTranslateArr !== null) {
            newKey =
              key.replace(toTranslateArr[0], '') +
              getText(`statistics.barLabels.${toTranslateArr[1]}`)
          } else {
            newKey = getText(`statistics.barLabels.${key}`) || key
          }
        }
        newItem[newKey] = item[key]
      })
      newArray.push(newItem)
    })
  }
  return normalizeBarData(newArray)
}

export const crunchToPieData = rawData => {
  const resultArray = []
  const agg = aggregateRawData(rawData)
  agg.forEach((val, key) => {
    resultArray.push({ name: key, value: val })
  })
  return resultArray
}
